import React, { useCallback, useState } from "react";
import { Button, Field, HStack, Input, Text } from "@chakra-ui/react";
import { useAppStore } from "../../../context/store";
import { useMapObjects } from "../../../context/MapObjectsContext";
import { getMinMaxZFromDataSources, toggleHeightFilteredPoints } from "../../../utilies/OtherUtility";

function SettingsMenuNodeHeight() {
  const { mapObjects } = useMapObjects();

  const filterNodeMinHeight = useAppStore((s) => s.filterNodeMinHeight);
  const filterNodeMaxHeight = useAppStore((s) => s.filterNodeMaxHeight);

  const setFilterNodeMinHeight = useAppStore.getState().setFilterNodeMinHeight;
  const setFilterNodeMaxHeight = useAppStore.getState().setFilterNodeMaxHeight;

  const viewerRef = useAppStore.getState().viewerRef;

  const [isNodeHeightToggled, setIsNodeHeightToggled] = useState(false);
  const [minNodeHeight, setMinNodeHeight] = useState(0);
  const [maxNodeHeight, setMaxNodeHeight] = useState(0);

  const collectAllDataSources = useCallback(() => {
    const temp = [];
    for (const key in mapObjects) {
      if (mapObjects[key].view_type === "lanelet") temp.push(mapObjects[key].osmDataSource);
      else temp.push(mapObjects[key].dataSource);
    }
    return temp;
  }, [mapObjects]);

  const recomputeMinMax = useCallback(() => {
    const temp = collectAllDataSources();
    const res = getMinMaxZFromDataSources(temp);
    setMinNodeHeight(res?.minZ ?? 0);
    setMaxNodeHeight(res?.maxZ ?? 0);
  }, [collectAllDataSources]);

  const settingNodeHeightToggle = () => {
    const temp = collectAllDataSources();
    const newToggle = !isNodeHeightToggled;
    setIsNodeHeightToggled(newToggle);
    toggleHeightFilteredPoints(viewerRef.current, temp, filterNodeMinHeight, filterNodeMaxHeight);
  };

  return (
    <>
      <HStack mb={2} gap={2} alignItems={"center"}>
        <Field.Root>
          <Field.Label>Min Height</Field.Label>
          <Input placeholder="Height greater than" type="number" value={filterNodeMinHeight} onChange={(v) => setFilterNodeMinHeight(v.target.value)} />
        </Field.Root>

        <Field.Root>
          <Field.Label>Max Height</Field.Label>
          <Input placeholder="Height greater than" type="number" value={filterNodeMaxHeight} onChange={(v) => setFilterNodeMaxHeight(v.target.value)} />
        </Field.Root>
      </HStack>

      <Text mb={2}>
        Min: {minNodeHeight} | Max: {maxNodeHeight}
      </Text>

      <HStack gap={2}>
        <Button width={"full"} onClick={settingNodeHeightToggle} colorPalette={isNodeHeightToggled ? "green" : "black"}>
          {isNodeHeightToggled ? "Hide" : "Show"}
        </Button>
      </HStack>
    </>
  );
}

export default SettingsMenuNodeHeight;
